var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlaticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flaticon",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13,8.73H7.54l-1.71-2.96H14.7l2.59-4.5H2.63c-.93,0-1.82,.5-2.28,1.32C-.12,3.41-.12,4.41,.36,5.23L9.71,21.44c.74,1.25,2.35,1.67,3.62,.93,.39-.24,.72-.54,.93-.93l.3-.54-4.3-7.46,2.74-4.71Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.65,2.59c-.48-.82-1.34-1.32-2.28-1.32h-.65l-7.03,12.16,2.57,4.5,7.35-12.73c.51-.79,.51-1.79,.03-2.61h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlaticon);
export default __webpack_public_path__ + "static/media/flaticon.0bce1d31bba45e126d43a8a055b89f64.svg";
export { ForwardRef as ReactComponent };